import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';

import { StorageService } from '../service/storage.service';
import { ADMIN_TOKEN, TOKEN, USER_ID } from '../constants/constant';
import { ToastrService } from 'ngx-toastr';
import { StateService } from '../service/state.service';
import { Router } from '@angular/router';
import { Data } from '../model/data.model';

export const TokenInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const localStorage = inject(StorageService);
  const toastr = inject(ToastrService);
  const stateService = inject(StateService);
  const router = inject(Router);

  const isAdmin = req.url.includes("Admin") || req.url.includes("admin");
  const jwt = isAdmin ? localStorage.getItem(ADMIN_TOKEN) : localStorage.getItem(TOKEN);

  const headers: Record<string, string> = {};
  if (jwt) {
    headers['authorization'] = `Bearer ${jwt}`;
  }

  const modifiedRequest = req.clone({ setHeaders: headers });

  return next(modifiedRequest).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const message = event.body?.meta?.status_message;

        if (message === 'Auth Expire') {
          localStorage.removeItem(ADMIN_TOKEN);
          toastr.info("Token expired. Please Log In again.");
          router.navigate(['/admin/login']);
        } else if (message === "User is not login" || message === "You are not login") {
          localStorage.removeItem(TOKEN);
          localStorage.removeItem(USER_ID);
          toastr.info("Token expired. Please Log In again.");
          router.navigate(['']);
        }
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      const data: Data<any> = error.error;

      if (error.status === 401) {
        if (router.url.includes('admin')) {
          router.navigate(['/admin/login']);
        } else {
          router.navigate(['']);
        }
        toastr.info("Please Log In again.");
        localStorage.removeItem(TOKEN);
        localStorage.removeItem(ADMIN_TOKEN);
        localStorage.removeItem(USER_ID);
        stateService.reloadGuestUser(true);
        stateService.isTokenFetch(true);
        stateService.sendPrivilegesMenu([]);
      }

      if (data?.meta) {
        toastr.error(data.meta.status_message);
      } else if (error.status === 0) {
        toastr.error('Request could not be completed.');
      } else {
        toastr.error(error.statusText);
      }

      stateService.shimmerLoaderUpdate(false);
      return throwError(() => error);
    })
  );
};
